import React from "react";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../i18n/LanguageContext";
import { Language } from "../i18n/translations";

const LanguageSelector: React.FC<{
  className?: string;
  variant?: "light" | "dark";
}> = ({ className = "", variant = "light" }) => {
  const { language, setLanguage, t } = useLanguage();

  const languages: { code: Language; name: string; countryCode: string }[] = [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "he", name: "עברית", countryCode: "il" },
    { code: "ru", name: "Русский", countryCode: "ru" },
    { code: "fr", name: "Français", countryCode: "fr" },
  ];

  const FlagImg = ({ countryCode }: { countryCode: string }) => (
    <img
      src={`https://flagcdn.com/24x18/${countryCode}.png`}
      srcSet={`https://flagcdn.com/48x36/${countryCode}.png 2x`}
      width="24"
      height="18"
      alt={countryCode}
      style={{ borderRadius: "2px", objectFit: "cover" }}
    />
  );

  const currentLanguage =
    languages.find((lang) => lang.code === language) || languages[0];

  return (
    <Dropdown className={className}>
      <Dropdown.Toggle
        variant={variant === "light" ? "outline-light" : "outline-secondary"}
        size="sm"
        className="d-flex align-items-center gap-2 border-0"
        style={{
          borderRadius: "6px",
          padding: "4px 10px",
          fontWeight: "500",
          background: "transparent",
          color: variant === "dark" ? "#212529" : undefined,
        }}
      >
        <FlagImg countryCode={currentLanguage.countryCode} />
        <span>{currentLanguage.name}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end" style={{ minWidth: "160px" }}>
        <Dropdown.Header className="small text-muted">
          {t("selectLanguage")}
        </Dropdown.Header>
        {languages.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            active={language === lang.code}
            onClick={() => setLanguage(lang.code)}
            className="d-flex align-items-center gap-2"
          >
            <FlagImg countryCode={lang.countryCode} />
            <span>{lang.name}</span>
            {language === lang.code && (
              <span className="ms-auto text-primary fw-bold">✓</span>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;
